module.exports = __webpack_public_path__ + "img/云采中心.e6ea4579.png";